import { z } from "zod";
import { EventEnvelopeSchema } from "../events/index.js";
const QUEUE_NAMES = [
  "system",
  "files",
  "dead-letter",
  "identity-events",
  "authz-sync-0",
  "authz-sync-1",
  "authz-sync-2",
  "authz-sync-3",
  "notifications",
  "notification-emails",
  "notification-digest",
  "reminders",
  "maintenance",
  "trash",
  "realtime",
  "sharing",
  "pdf",
  "einvoicing",
  "einvoicing-jobs",
  "billing",
  // REL-BE-01: organisation and personal data exports (core: the worker reads every table).
  "exports",
  // REL-BE-01: the daily deletion of organisations whose request is due.
  "privacy",
  // GEDX-BE-02: the OpenSearch index of document texts (core: it holds the search credentials).
  "search"
];
const QueueNameSchema = z.enum(QUEUE_NAMES);
const FILES_PROCESS_QUEUES = ["files", "pdf"];
const EventJobSchema = EventEnvelopeSchema;
const DeadLetterJobSchema = z.strictObject({
  queue: QueueNameSchema,
  jobId: z.string(),
  job: EventJobSchema,
  attempts: z.int(),
  failedAt: z.iso.datetime({ offset: true }),
  /** Error message only (never a stack or payload). */
  error: z.string().max(1e3)
});
export {
  DeadLetterJobSchema,
  EventJobSchema,
  FILES_PROCESS_QUEUES,
  QUEUE_NAMES,
  QueueNameSchema
};
//# sourceMappingURL=index.js.map